export { TODAYS_TOP_HITS_ID } from "@libs/utils";

export const MAX_DOWNLOAD_ATTEMPTS = 3;
export const DOWNLOAD_DIR = "";

export const OFFLINE_LIBRARY_QUERY_KEY = "offline-library";
